import { render, staticRenderFns } from "./ScheduledFormDetailedView.vue?vue&type=template&id=37986f3a&"
import script from "./ScheduledFormDetailedView.vue?vue&type=script&lang=ts&"
export * from "./ScheduledFormDetailedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports